import { SyncAlertIcon } from './SyncAlertIcon';

/**
 * author: Google
 * id 66A07118-4C78-44D0-8B73-930144C74BD1
 * name sync-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sync-alert.svg
 * tags
 * - Alert / Error 
 */
export const SyncWarningIcon = SyncAlertIcon;
export default SyncWarningIcon